import { useEffect, useRef } from "react";

import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { AnnouncementType } from "@classview/shared-types";

import { useGetActiveAnnouncements } from "../api/get-active-announcements";

export function AnnouncementBanner() {
  const bannerRef = useRef<HTMLDivElement>(null);
  const { organisation } = useOrganisation();
  const { data: activeAnnouncements, isSuccess } = useGetActiveAnnouncements(
    organisation.id,
    {
      select: (data) =>
        data.filter(
          (announcement) => announcement.type === AnnouncementType.NOTICE,
        ),
    },
  );

  const hasActiveAnnouncements = isSuccess && activeAnnouncements.length > 0;

  useEffect(() => {
    if (bannerRef.current && hasActiveAnnouncements) {
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty(
        "--announcements-banner-offset",
        `${height}px`,
      );

      return () => {
        document.documentElement.style.setProperty(
          "--announcements-banner-offset",
          "0px",
        );
      };
    }
  }, [activeAnnouncements, hasActiveAnnouncements]);

  if (!hasActiveAnnouncements) return null;

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 z-50 w-full space-y-2 bg-primary px-4 py-5 shadow lg:pl-72"
    >
      {activeAnnouncements.map((announcement) => (
        <p key={announcement.id} className="text-sm text-white/70">
          <b className="text-white">{announcement.title}</b>{" "}
          {announcement.message}
        </p>
      ))}
    </div>
  );
}
